import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject'; 


@Injectable()
export class GetFilteredDataService {

  public filtered_data_partial_subj : Subject<any> = new Subject();
  public filtered_data_subj : Subject<any> = new Subject();
  public search_triggered_subj : Subject<any> = new Subject();

  constructor() { }

}



// WEBPACK FOOTER //
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/app/display-profiles/filter/get-filtered-data.service.ts